// import './particles.js';
// import data from '../particles.json';
// const json = JSON.parse(JSON.stringify(data));
// console.log(particlesJS)
// console.log(json)

class ParticlesBg {
  constructor(el) {
    this.dom = {el: el};

    this.init();
  }

  init() {
    particlesJS.load(this.dom.el.id, './assets/js/particlesjs-config.json', () => {
      console.log('callback - particles.js config loaded');
    });
  }
}

export default ParticlesBg;
